<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;height: 400px; top: 70%;left: 64%;transform: translate(-50%, -50%);z-index: 1;}
.title{width: 660px; height: 30px;background: rgba(33, 185, 191, 0.9);margin: 0;line-height: 30px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-content {width: 690px;height: 350px;;color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;}
.ol-popup-closer:after {content: "✖";}
//设置整个table样式
/deep/.el-table{background: none !important;}
//修改表格头部样式
/deep/.el-table tr {background: none !important; }
/deep/.el-table tr .is-center{background: none !important; color: #fff; border: none;}
//修改分页菜单yangs
/deep/.el-pager li{background: transparent !important; color: #fff;}
/deep/.el-pager > .active{background: transparent !important; color: #23fffc;}
/deep/.btn-prev{background: transparent !important;color: #fff !important;}
/deep/.btn-next{background: transparent !important;color: #fff !important;}
/deep/.el-table__header th {padding: 0;height: 30px;}
/deep/.el-table__body td {padding: 0;height: 30px;}
.echarts {height: 40px;line-height: 40px;}
.echarts span{display: inline-block;height: 30px;line-height: 30px;;border: 1px solid rgba(33, 185, 191, 0.6);padding: 0px 5px;}
.echarts span:hover {cursor: pointer;}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>{{this.typeName}}</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content" id="content"></div>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      flag: false,
      xAxis: [],
      yAxis: [],
      series: [],
      typeName: ''
    }
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.flag = show
    },
    show(show, xAxis, yAxis, series, typeName)
    {
      this.flag = show
      this.xAxis = xAxis
      this.yAxis = yAxis
      this.series = series
      this.typeName = typeName
      this.$nextTick(function()
      {
        this.drawLine()
      })
    },
    drawLine()
    {
      let chart = this.$echarts.init(document.getElementById('content'))
      let option = {
        tooltip: {
          trigger: 'item'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        // 网格
        grid: {
          y: 40,
          x: 80,
          y2: 80,
          backgroundColor: 'rgba(0,0,0,0)',
          borderWidth: 1,
          borderColor: '#ccc'
        },
        legend: {
          orient: 'vertical',
          left: 'top',
          show: true,
          right: 0,
          top: 20,
          bottom: 20,
          textStyle: {
            fontSize: 12,
            color: '#FFF'
          }
        },
        xAxis: [],
        yAxis: [],
        series: []
      }
      option.xAxis = this.xAxis
      option.yAxis = this.yAxis
      option.series = this.series
      setTimeout(chart.setOption(option, true), 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Echarts.vue